import Booklet from "./Booklet";
import Disclosure from "./Disclosure";
import NavigationMenu from "./NavigationMenu";
import OverscrollIndicator from "./OverscrollIndicator";
import Popover from "./Popover";
import Sidebar from "./Sidebar";
import Tooltip from "./Tooltip";

function defineElements() {
  if ("customElements" in window) {
    Booklet.define();
    Disclosure.define();
    NavigationMenu.define();
    OverscrollIndicator.define();
    Popover.define();
    Sidebar.define();
    Tooltip.define();
  }
}

export {
  Booklet,
  Disclosure,
  NavigationMenu,
  OverscrollIndicator,
  Popover,
  Sidebar,
  Tooltip,
  defineElements,
};
